module.exports = __webpack_public_path__ + "img/38_8.ca28bc6f.png";